import { withStyles } from '../../tools/withStyles';
import { Component } from './Animation';

const Animation = withStyles(() => ({}))(Component);

export { Animation };
